import { CWCCollectionCardProps } from './components/CWCCollectionCard/CWCCollectionCard'

import nightOffWebp from '../../assets/WeeklyCollectionsSectionAssets/coll-nightoff.webp'
import nightOffPng from '../../assets/WeeklyCollectionsSectionAssets/coll-nightoff.png'
import healthWebp from '../../assets/WeeklyCollectionsSectionAssets/coll-health.webp'
import healthPng from '../../assets/WeeklyCollectionsSectionAssets/coll-health.png'
import kidsWebp from '../../assets/WeeklyCollectionsSectionAssets/coll-kids.webp'
import kidsPng from '../../assets/WeeklyCollectionsSectionAssets/coll-kids.png'
import dateNightWebp from '../../assets/WeeklyCollectionsSectionAssets/coll-datenight.webp'
import dateNightPng from '../../assets/WeeklyCollectionsSectionAssets/coll-datenight.png'
import takeawayWebp from '../../assets/WeeklyCollectionsSectionAssets/coll-takeaway.webp'
import takeawayPng from '../../assets/WeeklyCollectionsSectionAssets/coll-takeaway.png'
import hostingWebp from '../../assets/WeeklyCollectionsSectionAssets/coll-hosting.webp'
import hostingPng from '../../assets/WeeklyCollectionsSectionAssets/coll-hosting.png'

// The six occasion cards in design order. Order is significant — the carousel renders them as-is.
export const WEEKLY_COLLECTIONS: CWCCollectionCardProps[] = [
  {
    caption: 'Night off',
    webp: nightOffWebp,
    fallback: nightOffPng,
    alt: 'Person opening a Gousto heat-and-eat Thai curry ready meal ready for dinner',
  },
  {
    caption: 'Health goals',
    webp: healthWebp,
    fallback: healthPng,
    alt: 'Serving bowl of a freshly made salad being dished up for dinner',
  },
  {
    caption: 'Family night',
    webp: kidsWebp,
    fallback: kidsPng,
    alt: 'Parent and child making a homemade pizza together in the kitchen, adding toppings to the dough',
  },
  {
    caption: 'Date night',
    webp: dateNightWebp,
    fallback: dateNightPng,
    alt: 'Couple sitting on a red sofa smiling and eating noodle bowls together for a date night at home',
  },
  {
    caption: 'Fakeaway',
    webp: takeawayWebp,
    fallback: takeawayPng,
    alt: 'Hands dipping chips and fried chicken into sauces at a table, takeaway-style meal',
  },
  {
    caption: 'Hosting',
    webp: hostingWebp,
    fallback: hostingPng,
    alt: 'Hands reaching for roasted potatoes, sausages and dips on a shared platter, hosting friends at the table',
  },
]
